// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__ExG1K","description":"PatientConsentPreview_description__3x8Lu"};